import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  faGripLinesVertical,
  faScrewdriver,
  faWind,
} from '@fortawesome/free-solid-svg-icons';
import { useFlag } from '@unleash/proxy-client-react';
import { useSheetViewer } from './SheetViewer';
import SparkelIcon from './icon/SparkelIcon';

// eslint-disable-next-line complexity
export default function SheetShapeLabelsButton(): React.ReactElement {
  const {
    protanVisuals: {
      isShowingWindLoadZones,
      setIsShowingWindLoadZones,
      isShowingTaperedInsulationSlices,
      setIsShowingTaperedInsulationSlices,
      isShowingFasteners,
      setIsShowingFasteners,
    },
  } = useSheetViewer();

  const { t } = useTranslation(['project', 'protan']);

  const enableTaperedInsulationFasteners = useFlag(
    'enable-tapered-insulation-fasteners'
  );

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <>
      <Tooltip label={t('protan:visuals.wind-load-zones')}>
        <IconButton
          aria-label={t('protan:visuals.wind-load-zones')}
          icon={
            <SparkelIcon
              icon={faWind}
              color={isShowingWindLoadZones ? activeIconColor : undefined}
            />
          }
          isRound
          isActive={isShowingWindLoadZones}
          colorScheme={isShowingWindLoadZones ? 'teal' : 'gray'}
          variant={isShowingWindLoadZones ? 'toggle' : 'solid-no-transparent'}
          size="xs"
          onClick={() => {
            setIsShowingWindLoadZones(!isShowingWindLoadZones);
          }}
        />
      </Tooltip>
      <Tooltip label={t('protan:visuals.tapered-insulation-slices')}>
        <IconButton
          aria-label={t('protan:visuals.tapered-insulation-slices')}
          icon={
            <SparkelIcon
              icon={faGripLinesVertical}
              color={
                isShowingTaperedInsulationSlices ? activeIconColor : undefined
              }
            />
          }
          isRound
          isActive={isShowingTaperedInsulationSlices}
          colorScheme={isShowingTaperedInsulationSlices ? 'teal' : 'gray'}
          variant={
            isShowingTaperedInsulationSlices ? 'toggle' : 'solid-no-transparent'
          }
          size="xs"
          onClick={() => {
            setIsShowingTaperedInsulationSlices(
              !isShowingTaperedInsulationSlices
            );
          }}
        />
      </Tooltip>
      {enableTaperedInsulationFasteners && (
        <Tooltip label={t('protan:visuals.fasteners')}>
          <IconButton
            aria-label={t('protan:visuals.fasteners')}
            icon={
              <SparkelIcon
                icon={faScrewdriver}
                color={isShowingFasteners ? activeIconColor : undefined}
              />
            }
            isRound
            isActive={isShowingFasteners}
            colorScheme={isShowingFasteners ? 'teal' : 'gray'}
            variant={isShowingFasteners ? 'toggle' : 'solid-no-transparent'}
            size="xs"
            onClick={() => {
              setIsShowingFasteners(!isShowingFasteners);
            }}
          />
        </Tooltip>
      )}
    </>
  );
}
